/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConfigureFaxWebhookDto
 */
export interface ConfigureFaxWebhookDto {
    /**
     * Public HTTPS base URL for this backend. Use an ngrok URL for local testing or the deployed API host for dev/staging.
     * @type {string}
     * @memberof ConfigureFaxWebhookDto
     */
    publicBaseUrl: string;
}

/**
 * Check if a given object implements the ConfigureFaxWebhookDto interface.
 */
export function instanceOfConfigureFaxWebhookDto(value: object): value is ConfigureFaxWebhookDto {
    if (!('publicBaseUrl' in value) || value['publicBaseUrl'] === undefined) return false;
    return true;
}

export function ConfigureFaxWebhookDtoFromJSON(json: any): ConfigureFaxWebhookDto {
    return ConfigureFaxWebhookDtoFromJSONTyped(json, false);
}

export function ConfigureFaxWebhookDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfigureFaxWebhookDto {
    if (json == null) {
        return json;
    }
    return {
        
        'publicBaseUrl': json['publicBaseUrl'],
    };
}

export function ConfigureFaxWebhookDtoToJSON(json: any): ConfigureFaxWebhookDto {
    return ConfigureFaxWebhookDtoToJSONTyped(json, false);
}

export function ConfigureFaxWebhookDtoToJSONTyped(value?: ConfigureFaxWebhookDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'publicBaseUrl': value['publicBaseUrl'],
    };
}

